<template>
  <label class="counter">
    <span><span v-text="value" :class="{valid: countIsValid}"></span> / {{minCount}}</span>
  </label>
</template>

<script>
  export default {
    props: ['value', 'minCount'],
    computed: {
      countIsValid() {
        return this.value >= this.minCount
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../sass/fct/variables';
  .counter {
    float: right;
    color: #c6c6c6;
    font-size: 12px;

    .valid {
      color: $active-color
    }
  }
</style>
